export const MODULE_NAME = 'jmtMembershipOverview';
